export const getEnvironmentConfig = () => {
    return {
        API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
        ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
        APP_NAME: import.meta.env.VITE_APP_NAME,
        VERSION: import.meta.env.VITE_VERSION,
    };
};

export const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

export const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
};
